import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => (
    <header>
        <div className="main-nav">
            <NavLink className="nav-link home-button" to="/">Home</NavLink>
            <NavLink className="nav-link" to="/about">About</NavLink>
            <NavLink className="nav-link" to="/projects/html">Projects</NavLink>
        </div>
    </header>
);

export default Header;